import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";
import {
  Box,
  Button,
  Center,
  Flex,
  Heading,
  Input,
  Spacer,
  useDisclosure,
  VStack,
  Image,
  Text,
  Select,
} from "@chakra-ui/react";
import UserTable from "../../components/UserTable/UserTable";
import { REQUEST_MASTER_USERS } from "../../store/users/userstActionTypes";
import { useUsersMaster } from "../../store/users/reducer";

const Usermanagement = () => {
  const { masterUsers, busy } = useUsersMaster();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatch = useDispatch();
  useEffect(() => {
    // if (!busy && !(masterCategory || []).length) {
    dispatch({ type: REQUEST_MASTER_USERS });
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [searchQuery, setSearch] = useState("");
  return (
    <>
      <VStack top={5} position="relative" key={"vStack"}>
        <Flex w="92%" alignItems="center" justifyContent="space-between">
          <Heading ml="8" size="md" fontWeight="semibold" color="black.400">
            User management
          </Heading>
          <Spacer></Spacer>
          <Heading size="sm" fontWeight="semibold">
            <Flex alignItems="center" gap={2}>
              <Image
                borderRadius="full"
                boxSize="50px"
                src="https://bit.ly/dan-abramov"
                alt="Dan Abramov"
              />
              <Text>Admin</Text>
            </Flex>
          </Heading>
        </Flex>
      </VStack>
      <UserTable query={""} />
    </>
  );
};

export default Usermanagement;
